const recordColumns = [
  { label: 'index', value: 'index', disabled: true },
  { label: 'where', value: 'where', disabled: true },
  { label: 'side', value: 'side', disabled: true },
  { label: 'location', value: 'location', disabled: true },
  { label: 'component', value: 'component', disabled: true },
];

export const defaultSelectedRecordColumns = recordColumns.map(
  (recordColumn) => recordColumn.value
);

export default recordColumns;
